import { DownloadLinkEnh } from "../../components/common/DownloadLink/DownloadLinkEnh";

export default function BerkasSidangCard({ mKSpesialId, jenisSidang }) {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-center">
        <b>Unduh:</b>
        <div>
          <DownloadLinkEnh
            downloadFilename={"label.pdf"}
            endpoint={`/file/label/?mk_spesial=${mKSpesialId}`}
            label={"Label"}
          />
        </div>
        <div>
          <DownloadLinkEnh
            endpoint={`/file/lembar-penilaian/?mk_spesial=${mKSpesialId}`}
            label={"Lembar Penilaian"}
          />
        </div>
        <div>
          <DownloadLinkEnh
            endpoint={`/file/lembar-pengesahan/?mk_spesial=${mKSpesialId}`}
            label={"Lembar Pengesahan"}
          />
        </div>
        <div>
          <DownloadLinkEnh
            endpoint={`/file/lembar-kehadiran-sidang/?mk_spesial=${mKSpesialId}`}
            label={"Lembar Kehadiran Sidang"}
          />
        </div>
      </div>
    </div>
  );
}
